(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/input-number/assets/javascripts/input-number.js') >= 0) return;  svs.modules.push('/components/components/input-number/assets/javascripts/input-number.js');
"use strict";


(function (svs) {
  const {
    isNumber,
    getValidValue,
    isWithinBounds
  } = svs.components.input_number.utils;
  function inputNumber(_ref) {
    let {
      el,
      onValueChange = () => {}
    } = _ref;
    if (!el) {
      throw new Error('el is not defined');
    }
    const {
      CLASS_ERROR,
      TOGGLE_ERROR_TIMEOUT,
      CLASS_INPUT,
      CLASS_BUTTONS
    } = svs.components.input_number.constants;
    const buttonClass = "js-".concat(CLASS_BUTTONS);
    const inputClass = "js-".concat(CLASS_INPUT);
    const [decBtn, incBtn] = el.querySelectorAll(".".concat(buttonClass));
    const input = el.querySelector(".".concat(inputClass));
    let value = input.valueAsNumber;
    let previousValue = input.valueAsNumber;
    let lastSubmittedValue = input.valueAsNumber;
    if (typeof value === 'undefined') {
      value = previousValue = lastSubmittedValue = input.value = 1;
    }
    const settings = {
      minValue: Number(input.getAttribute('min')) || -Infinity,
      maxValue: Number(input.getAttribute('max')) || Infinity,
      negativeStep: Number(decBtn.dataset.step) || -1,
      positiveStep: Number(incBtn.dataset.step) || 1
    };
    const _onValueChange = _ref2 => {
      let {
        target,
        type
      } = _ref2;
      if (target.classList.contains(buttonClass) || type === 'input') {
        const step = Number(target.dataset.step);
        const newValue = isNaN(step) ? target.valueAsNumber : value + step;
        if (isNumber(newValue) || target.value === '') {
          const validValue = updateValue(newValue, type);
          if (isNumber(newValue)) {
            if (lastSubmittedValue !== validValue && (isWithinBounds(newValue, settings) || ~[settings.maxValue, settings.minValue].indexOf(validValue))) {
              onValueChange(validValue);
              lastSubmittedValue = validValue;
            }
            validValue !== newValue && onError();
            previousValue = validValue;
          }
        } else {
          onError();
        }
      }
    };
    const _onBlur = () => {
      if (!isNumber(value) || !isWithinBounds(value, settings)) {
        const validValue = updateValue(previousValue);
        if (lastSubmittedValue !== validValue) {
          onValueChange(validValue);
          lastSubmittedValue = validValue;
        }
      }
    };
    const _onFocus = _ref3 => {
      let {
        target
      } = _ref3;
      target.select && target.select();
      previousValue = value;
    };
    const updateValue = (newValue, type) => {
      const validValue = getValidValue(newValue, previousValue, settings);
      value = input.value = isNumber(newValue) ? newValue < validValue && type !== 'click' ? newValue : validValue : '';
      decBtn.disabled = !(value > settings.minValue);
      incBtn.disabled = !(value < settings.maxValue);
      return validValue;
    };
    const onError = () => {
      el.classList.add(CLASS_ERROR);
      setTimeout(() => el.classList.remove(CLASS_ERROR), TOGGLE_ERROR_TIMEOUT);
    };
    updateValue(value);
    el.addEventListener('click', _onValueChange, false);
    input.addEventListener('input', _onValueChange, false);
    input.addEventListener('focus', _onFocus, false);
    input.addEventListener('blur', _onBlur, false);
    const destroy = () => {
      el.removeEventListener('click', _onValueChange);
      input.removeEventListener('input', _onValueChange);
      input.removeEventListener('focus', _onFocus);
      input.removeEventListener('blur', _onBlur);
    };
    return {
      destroy,
      getValue() {
        return value;
      }
    };
  }
  svs.components.input_number.inputNumber = inputNumber;
})(svs);

 })(window);